// extracted by mini-css-extract-plugin
export var container = "TextColumn-module--container--3a363";